import React, {Component} from 'react';
import {Provider} from "react-redux";
import {ConnectedRouter} from "react-router-redux";
import {PersistGate} from 'redux-persist/lib/integration/react'
import {CssBaseline, MuiThemeProvider, createMuiTheme} from '@material-ui/core';

import store, {history, persistor} from "./redux/store";
import DefaultTheme from './themes'

import Router from './containers/Router'

class App extends Component {

    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <MuiThemeProvider theme={createMuiTheme(DefaultTheme)}>
                        <PersistGate persistor={persistor}>
                            <CssBaseline/>
                            <Router/>
                        </PersistGate>
                    </MuiThemeProvider>
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js